import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './app/environments/environment';

if (environment.enableConsoleLogs === false) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
